/**
 * Multiple diagnosis codes follow the account column.
 * A clinic value does not open the editor when the clinic belongs to an account.
 */
export function accountMultipleDiagnosesEnabled(source: {
  hasParent: boolean;
  parentEnabled?: boolean | null;
  selfEnabled?: boolean | null;
}): boolean {
  if (source.hasParent) return source.parentEnabled === true;
  return source.selfEnabled === true;
}
